/* eslint react-hooks/exhaustive-deps: "warn" */

import { useRef } from 'react';

import cn from 'classnames';

import { useIntersection } from 'hooks/useIntersection';

import styles from './CrmEnrichDemo.module.scss';

import type { CrmEnrichDemoProps } from './CrmEnrichDemo.types';

export const CrmEnrichDemo = ({ record, className }: CrmEnrichDemoProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const play = useIntersection(ref, { threshold: 0.3 });

  return (
    <div
      ref={ref}
      className={cn(styles.demo, play && styles.play, className)}
      aria-label="Animated preview of a CRM record being enriched with registry data"
    >
      <div className={styles.crms}>
        <span className={styles.crmsLabel}>Syncs to</span>

        <div className={styles.crmsLogos}>
          {record.syncsTo.map((name) => (
            <span key={name} className={styles.crmChip}>
              {name}
            </span>
          ))}
        </div>
      </div>

      <div className={styles.head}>
        <div>
          <div className={styles.co}>{record.companyName}</div>
          <div className={styles.sub}>{record.companyMeta}</div>
        </div>

        <span className={styles.badge}>{record.badge}</span>
      </div>

      <div className={styles.fields}>
        {record.fields.map((field, i) => (
          <div
            key={field.label}
            className={styles.field}
            style={play ? { animationDelay: `${0.15 + i * 0.13}s` } : undefined}
          >
            <span className={styles.fieldLabel}>{field.label}</span>

            <span className={styles.fieldRight}>
              <span className={styles.fieldVal}>{field.value}</span>
              <span className={styles.fieldSrc}>{field.source}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
